import { createContext, useReducer } from "react";
import secureLocalStorage from "react-secure-storage";

export const NoteState = createContext();

const parseJSON = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};
export const isAdminRole = (role) => role?.toLowerCase() === "admin";
const accessToken = localStorage.getItem("access-token");
const branch_id = secureLocalStorage.getItem("branchId");
const UId = secureLocalStorage.getItem("UId");
const CId = secureLocalStorage.getItem("CId");
const role = secureLocalStorage.getItem("role");
const modules = secureLocalStorage.getItem("modules");

const initialState = {
  accessToken: parseJSON(accessToken),
  branch_id: parseJSON(branch_id),
  UId: parseJSON(UId),
  CId: parseJSON(CId),
  role: parseJSON(role),
  modules: parseJSON(modules) || [],
};

function reducer(state, action) {
  switch (action.type) {
    case "LOGIN":
      localStorage.setItem("access-token", JSON.stringify(action.accessToken));
      secureLocalStorage.setItem("branchId", JSON.stringify(action.branchId));
      secureLocalStorage.setItem("UId", JSON.stringify(action.UId));
      secureLocalStorage.setItem("CId", JSON.stringify(action.CId));
      secureLocalStorage.setItem("role", JSON.stringify(action.role));
      secureLocalStorage.setItem("modules", JSON.stringify(action.modules));
      return {
        ...state,
        accessToken: action.accessToken,
        branch_id: action.branchId,
        UId: action.UId,
        CId: action.CId,
        role: action.role,
        modules: action.modules,
      };
    case "REGISTER":
      secureLocalStorage.setItem("branchId", JSON.stringify(action.branchId));
      return {
        ...state,
        branch_id: action.branchId,
      };
    case "LOGOUT":
      localStorage.removeItem("access-token");
      secureLocalStorage.removeItem("branchId");
      secureLocalStorage.removeItem("UId");
      secureLocalStorage.removeItem("CId");
      secureLocalStorage.removeItem("role");
      secureLocalStorage.removeItem("modules");
      return {
        ...state,
        accessToken: null,
        branch_id: null,
        UId: null,
        CId: null,
        role: null,
        modules: [],
      };
    default:
      return state;
  }
}

export function UserProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };

  return (
    <NoteState.Provider value={value}>{props.children}</NoteState.Provider>
  );
}
